
import modelBase from '../../models/model-base.model';
import modelBaseV2 from '../../models/model-base-v2.model';

const fileModel = {
  getImageFile: function (successCallBack, failureCallBack, fileMasterid) {
    const path = '/api/file/image/' + fileMasterid;
    modelBase.get(successCallBack, failureCallBack, path);
  },
  getUserImageFile: function (successCallBack, failureCallBack, fileMasterid) {
    const path = '/api/user/image/' + fileMasterid;
    modelBase.get(successCallBack, failureCallBack, path);
  },
  getSurveyImageFile: function (successCallBack, failureCallBack, fileMasterid) {
    const path = '/api/survey/image/' + fileMasterid;
    modelBase.get(successCallBack, failureCallBack, path);
  },
  uploadMultipleFiles: (formData, category) => {
    return modelBaseV2.post(`/api/retail/file/${category}/multiple`, { body: formData });
  },
  downloadByFileId: (fileId, fileName) => {
    return modelBaseV2.getDownload(`/api/retail/file/${encodeURIComponent(fileId)}`, {}, fileName);
  },
  downloadByFileIdV2: (params, fileName) => {
    return modelBaseV2.getDownload('/api/survey/download', {params}, fileName);
  }
}

export default fileModel
